import { type Question } from '@/types'

import { generateSpanField } from './generateSpanField'
import { getQuestionInfo } from './getQuestionInfo'

const extractTokensFromSecondPart = (formula: string) => {
  const extractParentheses = formula
    ?.replace(/^COUNTIFS\(|\)$/g, '')
    ?.split(',')
  const getSecondPartFromFormula = extractParentheses?.[1]

  if (getSecondPartFromFormula) {
    const tokenRegex = /([QR]\d+|\d+\.\d+|\d+|[()+\-*/=><])/g
    const tokens = getSecondPartFromFormula?.match(tokenRegex) || []

    return tokens
  }
  return []
}

export const generateCOUNTIFS = (questions: Question[], formula: string) => {
  const addFieldRegex = /(QR\d+_\d+|[QR]\d+):(QR\d+_\d+|[QR]\d+)/g
  const getAddFieldMatch = [...(formula?.matchAll(addFieldRegex) || [])]
  const addField = getAddFieldMatch?.flatMap((match) => [
    match?.[1],
    match?.[2],
  ])
  const getTokensFromSecondPart = extractTokensFromSecondPart(formula)

  const initialFieldFormIndex = addField?.[0] || ''
  const initialField = getQuestionInfo(questions, initialFieldFormIndex)

  const endFieldFormIndex = addField?.[1] || ''
  const endField = getQuestionInfo(questions, endFieldFormIndex)

  return `<span
      data-description="Click to change function"
      data-function="countifs"
      data-type="function"
    >
      COUNTIFS
    </span>
    <span data-type="parentheses">(</span>
    ${generateSpanField({ description: initialField?.description || '', questionId: initialField?.formIndex ? undefined : initialField?.questionId, rowOrder: initialField?.formIndex ? undefined : initialField?.rowOrder, order: '0', type: 'addField', value: initialFieldFormIndex, formIndex: initialField?.formIndex })}
    <span data-type="rangeSeparator">:</span>
    ${generateSpanField({ description: endField?.description || '', questionId: endField?.formIndex ? undefined : endField?.questionId, rowOrder: endField?.formIndex ? undefined : endField?.rowOrder, order: '1', type: 'addField', value: endFieldFormIndex, formIndex: endField?.formIndex })}
    <span data-type="comma">,</span>
    <span data-placeholder="countifs" data-type="wrapperPlaceholder">
      <span data-color="blue" data-type="placeholder" style="display: none;">
        value
      </span>
      <span
        contenteditable="true"
        data-description="Click and type to add a value"
        data-mask="input"
        data-order="2"
        data-type="value"
      >
        ${getTokensFromSecondPart
          .map((token) => {
            if (/^[QR]/.test(token)) {
              const tokenInfo = getQuestionInfo(questions, token)
              return generateSpanField({
                description: tokenInfo?.description || '',
                type: 'addedField',
                value: token,
              })
            }
            return token
          })
          .join('')}
      </span>
    </span>
    <span data-type="parentheses">)</span>`
}
